import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Alert } from "~/types/component";

type ScreenState = {
  loading: boolean;
  showAlert: boolean;
  alert: Alert | null;
};

const initialState: ScreenState = {
  loading: false,
  showAlert: false,
  alert: null,
};

const screenModule = createSlice({
  name: "admin/screen",
  initialState,
  reducers: {
    setLoading: (state: ScreenState, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError(state: ScreenState, action: PayloadAction<string>) {
      const message = action.payload;
      const alert: Alert = {
        message: message,
        type: "error",
      };
      state.showAlert = true;
      state.alert = alert;
    },
    setSuccess(state: ScreenState, action: PayloadAction<string>) {
      const message = action.payload;
      const alert: Alert = {
        message: message,
        type: "success",
      };
      state.showAlert = true;
      state.alert = alert;
    },
    resetAlert(state: ScreenState) {
      state.showAlert = false;
      // state.alert = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setSuccess,
  resetAlert,
} = screenModule.actions;

export default screenModule;
